(() => {
  const replacements = [
    ['供货情况', 'Availability'],
    ['价格', 'Price'],
    ['tony@dqgroupinc.com', 'Tony@dqgroupinc.com']
  ];

  const fixText = (value) => replacements.reduce((text, pair) => text.split(pair[0]).join(pair[1]), value);

  const fixNode = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const fixed = fixText(node.nodeValue || '');
      if (fixed !== node.nodeValue) node.nodeValue = fixed;
      return;
    }

    if (!(node instanceof Element)) return;

    if (node.matches('a[href^="mailto:"]')) {
      node.setAttribute('href', node.getAttribute('href').replace('tony@dqgroupinc.com', 'Tony@dqgroupinc.com'));
    }

    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(fixNode);
  };

  const run = () => fixNode(document.body);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach(fixNode));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
